import React from 'react';
import { styled, Theme } from "@mui/material";
import { GroupSummariesCard } from "@securspace/securspace-ui-kit";

// if this is needed elsewhere extract it into its own directory
const Root = styled(GroupSummariesCard)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexGrow: '1',
  marginTop: theme.spacing(4),
}));

type GroupSummariesCardFullScreenAdditionalProps = React.ComponentPropsWithoutRef<'div'> & {
}

const GroupSummariesCardFullScreen = ({ children, ...rest}: GroupSummariesCardFullScreenAdditionalProps) => {
  return <Root {...rest}>
    { children }
  </Root>
}

export { GroupSummariesCardFullScreen };
